import React, { Component } from 'react'
import InvoiceProductForm from './InvoiceProductForm'
import { InvoiceService } from '../../../services'
import { startFetch, endFetch } from '../../../actions/generalActions'
import { connect } from 'react-redux'
import ToastService from '../shared/Toast/ToastService'
import { prefix } from '../../../i18n'

const tInvoice = prefix('invoice')

class InvoiceProductFormContainer extends Component {
  state = {
    brands: [],
    categories: [],
    products: [],
    saleTypes: [],
    selectedBrand: null,
    selectedCategory: null,
    selectedProduct: null,
    selectedSaleType: null,
  }

  clientId() {
    return this.props.client && this.props.client.slug
  }

  componentDidMount() {
    const { campaign } = this.props
    const clientId = this.clientId()

    // Load sale types and top-level categories ("Marca") in parallel
    this.props.startFetch()
    Promise.all([
      InvoiceService.getSaleTypes({ clientId: clientId, campaignId: campaign.slug }),
      InvoiceService.getClientCategories({ clientId: clientId, parentId: null }),
    ])
      .then(function(results) {
        const saleTypes = results[0].data.sale_types || []
        const brands    = results[1].data.client_categories || []
        this.setState({ saleTypes: saleTypes, brands: brands })
        this.props.endFetch()
      }.bind(this))
      .catch(function() { this.props.endFetch() }.bind(this))
  }

  // Brand selected → products link directly to the brand (no sub-category level exists)
  handleBrandChange = (brand) => {
    this.setState({ selectedBrand: brand, selectedCategory: null, selectedProduct: null, categories: [], products: [] })
    if (!brand) return
    const clientId = this.clientId()
    InvoiceService.getClientProducts({ clientId: clientId, parentId: brand.id })
      .then(function(response) {
        this.setState({ products: response.data.client_products || [] })
      }.bind(this))
      .catch(function() {})
  }

  // Kept for future use — currently no sub-category level exists in the backend data
  handleCategoryChange = (category) => {
    this.setState({ selectedCategory: category, selectedProduct: null, products: [] })
  }

  handleProductChange = (product) => {
    this.setState({ selectedProduct: product })
  }

  handleSaleTypeChange = (saleType) => {
    this.setState({ selectedSaleType: saleType })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const { selectedBrand, selectedCategory, selectedProduct, selectedSaleType } = this.state
    const quantity = e.target.quantity ? e.target.quantity.value : 1

    if (!selectedSaleType) { ToastService.error(tInvoice('select-sale-type')); return }
    if (!selectedBrand)    { ToastService.error(tInvoice('select-brand')); return }
    if (!selectedProduct)  { ToastService.error(tInvoice('select-product')); return }

    this.props.onSubmit({ selectedBrand, selectedCategory, selectedProduct, selectedSaleType, quantity })
  }

  render() {
    const { brands, categories, products, saleTypes, selectedBrand, selectedCategory, selectedProduct, selectedSaleType } = this.state
    const { createMode, onCancel } = this.props

    return (
      <InvoiceProductForm
        brands={brands}
        categories={categories}
        products={products}
        saleTypes={saleTypes}
        selectedBrand={selectedBrand}
        selectedCategory={selectedCategory}
        selectedProduct={selectedProduct}
        selectedSaleType={selectedSaleType}
        onBrandChange={this.handleBrandChange}
        onCategoryChange={this.handleCategoryChange}
        onProductChange={this.handleProductChange}
        onSaleTypeChange={this.handleSaleTypeChange}
        onSubmit={this.handleSubmit}
        onCancel={onCancel}
        createMode={createMode}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  client: state.userReducer.client,
})

const mapDispatchToProps = (dispatch) => ({
  startFetch: () => dispatch(startFetch()),
  endFetch: () => dispatch(endFetch()),
})

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceProductFormContainer)
